'use client';

import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';
import { SearchFilter } from '~/apis/search';

export const useStoredSearchFilters = (filters?: SearchFilter[]) => {
  const queryClient = useQueryClient();
  const queryKey = useMemo(() => ['searchFilters'], []);
  const { data } = useQuery({
    queryKey,
    placeholderData: (prev) => prev,
  });

  useEffect(() => {
    if (!filters) return;
    queryClient.setQueryData(queryKey, filters);
  }, [queryClient, queryKey, filters]);

  return filters ?? (data as SearchFilter[]);
};
